module.exports = __webpack_public_path__ + "media/fpa_digitalschool_intro_01.8d790e91.mp4";